/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-27 12:55:55
 *
 * LastModified: 2017-05-27 12:55:55
 *-------------------------------------------------------*/

function glassesGroupDetail(state = {}, action) {
  switch (action.type) {
    case 'CLEAR_GLASSES_GROUP_STATE':
      return {}
    case 'GET_GLASSES_GROUP_SUCCESS': {
      return action.payload
    }
    default:
      return state
  }
}

export default glassesGroupDetail



// WEBPACK FOOTER //
// ./routes/app/routes/glasses-group-detail/reducer/index.js